var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMpNavLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 53,
    viewBox: "0 0 80 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5449 53L52.5542 52.995L46.5312 40.9464L53.606 26.778L59.5495 38.9954L66.5449 53Z",
    fill: "#FF5C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9996 26.0681L66.5448 53L59.5494 38.9954L66.009 26.0681L59.986 13.9996L59.9662 13.9649L53.6059 26.778L46.7246 12.833L53.1395 0H66.9764L79.9996 26.0681Z",
    fill: "#FFB800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6066 26.778L40.5089 53H26.6621L46.7254 12.833L53.6066 26.778Z",
    fill: "#000573"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7249 12.833L39.6055 27.0908L33.2402 14.362L40.4043 0.0148926L46.7249 12.833Z",
    fill: "#FF5C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2403 14.362L13.9361 53H0L26.0713 0.0148926L33.2403 14.362Z",
    fill: "#000573"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpNavLogo);
export default __webpack_public_path__ + "static/media/mp-nav-logo.f9420bbefc941c085fa1346754454b8d.svg";
export { ForwardRef as ReactComponent };